module.exports = __webpack_public_path__ + "/images/ico-empty-list.98b5405.svg";